module.exports = __webpack_public_path__ + "static/cloud-visibility-a8df7b61cbb4332a15c48e1360fff341.mp4";